import { gql } from "@apollo/client";

export const SEND_FEEDBACK_EMAIL = gql`
  mutation SendFeedbackEmail($data: contactData!) {
    sendFeedbackEmail(data: $data)
  }
`;
